// src/mock/clusterDummyData.js

const clusterDummyData = {
  Master1: {
    nodes: {
      'master1-node-1': {
        id: 'edge-node',
        cpuArchitecture: 'x86_64',
        resources: {               // total memory
          memoryInBytes: 32 * 1024 * 1024 * 1024,   // 32 GiB
        },
        available_resources: {     // free memory
          memoryInBytes: 18 * 1024 * 1024 * 1024,   // 18 GiB
        },
        pods: {
          'cluster-manager-abc': {
            name: 'cluster-manager-abc',
            labels: { app: 'cluster-manager' },
          },
          'monitoring-agent-1': {
            name: 'monitoring-agent-1',
            labels: { app: 'monitoring-agent' },
          },
          'video-analytics-1': {
            name: 'video-analytics-1',
            labels: { app: 'video-analytics' },
          },
        },
      },

      'master1-node-2': {
        id: 'edge-node',
        cpuArchitecture: 'arm64',
        resources: {
          memoryInBytes: 16 * 1024 * 1024 * 1024,   // 16 GiB
        },
        available_resources: {
          memoryInBytes: 6 * 1024 * 1024 * 1024,    // 6 GiB
        },
        pods: {
          'monitoring-agent-2': {
            name: 'monitoring-agent-2',
            labels: { app: 'monitoring-agent' },
          },
          'db-service-1': {
            name: 'db-service-1',
            labels: { k8s_app: 'database' },
          },
        },
      },
    },
  },

  Master3: {
    nodes: {
      'master3-node-1': {
        id: 'cloud-node',
        cpuArchitecture: 'x86_64',
        resources: {
          memoryInBytes: 64 * 1024 * 1024 * 1024,   // 64 GiB
        },
        available_resources: {
          memoryInBytes: 40 * 1024 * 1024 * 1024,   // 40 GiB
        },
        pods: {
          'cluster-manager-xyz': {
            name: 'cluster-manager-xyz',
            labels: { app: 'cluster-manager' },
          },
          'logging-agent-1': {
            name: 'logging-agent-1',
            labels: { app: 'logging-agent' },
          },
          'alerting-service-1': {
            name: 'alerting-service-1',
            labels: { k8s_app: 'alerting-service' },
          },
        },
      },

      'master3-node-2': {
        id: 'edge-node',
        cpuArchitecture: 'arm64',
        resources: {
          memoryInBytes: 8 * 1024 * 1024 * 1024,    // 8 GiB
        },
        available_resources: {
          memoryInBytes: 2 * 1024 * 1024 * 1024,    // 2 GiB
        },
        pods: {
          'monitoring-agent-3': {
            name: 'monitoring-agent-3',
            labels: { app: 'monitoring-agent' },
          },
          'video-analytics-2': {
            name: 'video-analytics-2',
            labels: { app: 'video-analytics' },
          },
        },
      },
    },
  },
};

export default clusterDummyData;
